// extracted by mini-css-extract-plugin
export default {"serviceContainer":"CalendlyInfo_serviceContainer__kJOjx","serviceDescription":"CalendlyInfo_serviceDescription__f7hwv"};